import { DateTime } from "luxon";

import { ArchiveCabinet, LiveUnit } from "@/api/map/types";

/* NOTE: Known mounting structures values from Horus::mounting_structures_mftrs
 * as of 08/2021 */
// 1,  None
// 3,  25 Ft Wood Pole
// 4,  30 Ft Wood Pole
// 6,  35 Ft Cement Pole
// 5,  35 Ft Wood Pole
// 17, 40 ft Cast Iron
// 8,  Building
// 14, Car
// 15, GoPro
// 16, Luminaire (DOT break-away)
// 2,  Metal Pole
// 12, Mini 12V ???
// 13, Mini AC  ???
// 7,  Radio Tower
// 11, SatTrailer
// 10, Trailer V1
// 19, Trailer V1+
// 18, Trailer V2
// 9,  Truck

export const isUnitActive = (activated?: string, deactivated?: string): boolean => {
    if (activated) {
        const activatedTime = DateTime.fromISO(activated).toSeconds();
        const now = DateTime.now().toSeconds();

        if (deactivated) {
            const deactivatedTime = DateTime.fromISO(deactivated).toSeconds();

            return activatedTime <= now && (activatedTime > deactivatedTime || deactivatedTime > now);
        }

        return activatedTime <= now;
    }

    return false;
};

export const isLiveUnit = (unit: LiveUnit | ArchiveCabinet): unit is LiveUnit => {
    return unit.hasOwnProperty("serial");
};
